import { getUID } from '@redviking/argonaut-util/src/getUID';
import { ArgoMaterialStatusEnum } from '@redviking/argonaut-util/types/db-enums/argo/material_status';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import type { NodeSpec } from './NodeSpec';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const updateMaterialStatusUiNodeSpec: NodeSpec<NodeCfg<'updateMaterialStatus'>> = {
    kindLabel: 'Update Material Status',
    nodeCategory: 'material',
    requiredSockets: [ 'trigger', 'materialId' ],
    controls: nodeCfg => ({
        status: defineControlOpts({
            cfg: {
                kind: 'selection',
                label: 'Status',
                items: [
                    { label: 'Pending', value: ArgoMaterialStatusEnum.Pending },
                    { label: 'In Progress', value: ArgoMaterialStatusEnum.InProgress },
                    { label: 'Scrapped', value: ArgoMaterialStatusEnum.Scrapped },
                    { label: 'Quarantined', value: ArgoMaterialStatusEnum.Quarantined },
                    { label: 'Manually Completed', value: ArgoMaterialStatusEnum.ManuallyCompleted },
                    { label: 'Completed', value: ArgoMaterialStatusEnum.Completed },
                ],
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.status,
        }),
    }),
    cfg: () => ({
        disabled: false,
        id: getUID(),
        kind: 'updateMaterialStatus',
        width: 200,
        controlValues: { status: ArgoMaterialStatusEnum.Completed },
    }),
    inputs: () => ({
        trigger: { socket: 'event', label: 'Trigger' },
        materialId: { socket: 'string', label: 'Material Id' },
    }),
    outputs: () => ({ next: { socket: 'event', label: 'Next' } }),
    validator: () => true,
};
